import { Box, MenuItem } from "@mui/material";
import { TablePlaceHolder } from "@app/components/PlaceHolder";
import { memo } from "react";
import { CarSelectField } from "@app/components/Inputs";
import { CarDownloadButton } from "@app/components/Buttons";
import {
  CarSimulationSummaryTable,
  useSimulationABTestSummary,
} from "./useSimulationABTestSummary";
import { SimulationABTestSummaryTable } from "./SimulationABTestSummaryTable";
import { CarPageContent } from "@app/components/PageContent";
import { CarPageContentCode, usePageContent } from "@app/hooks/usePageContent";
import { CollapseSection } from "./SimulationDetailsSummary";

interface SimulationABTestSummaryProps {
  simulationJobIdA: string;
  simulationJobIdB: string;
}

const TableSection = ({ table }: { table: CarSimulationSummaryTable }) => {
  return (
    <CollapseSection label={table.name}>
      <SimulationABTestSummaryTable table={table} />
    </CollapseSection>
  );
};

export const SimulationABTestSummary = memo(
  (props: SimulationABTestSummaryProps) => {
    const simulationSummary = useSimulationABTestSummary({
      simulationJobIdA: props.simulationJobIdA,
      simulationJobIdB: props.simulationJobIdB,
    });

    const pageContent = usePageContent();

    return (
      <TablePlaceHolder
        sx={{ mx: 7, mt: 5 }}
        isLoading={simulationSummary.isLoading || pageContent.isLoading}
        rows={8}
      >
        <CarPageContent
          sx={{ mb: 3 }}
          content={pageContent.getContent(
            CarPageContentCode.SIMULATION_ANALYSIS_AB_TEST_SUMMARY,
          )}
          isWhiteContext
        />
        <Box sx={{ mt: 1, display: "flex", gap: 5, alignItems: "flex-end" }}>
          <CarSelectField
            label="Asset Class Groupings"
            sx={{
              width: 216,
              ".MuiInputLabel-root": {
                fontSize: "16px",
              },
              ".MuiOutlinedInput-root": {
                marginTop: "28px",
                bgcolor: "white",
              },
            }}
            value={simulationSummary.assetClassGroupSelector.value}
            onChange={simulationSummary.assetClassGroupSelector.onChange}
          >
            {simulationSummary.assetClassGroupSelector.items.map((i) => (
              <MenuItem key={i.code} value={i.code}>
                {i.name}
              </MenuItem>
            ))}
          </CarSelectField>
          <CarDownloadButton
            sx={{ ml: "auto", mb: 0.5 }}
            onClick={simulationSummary.handleDownloadReports}
          >
            Download Reports
          </CarDownloadButton>
        </Box>
        {simulationSummary.tables.map((table, idx) => (
          <TableSection key={idx} table={table} />
        ))}
      </TablePlaceHolder>
    );
  },
);
